import {
  Box,
  Show,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { useState } from 'react';
import { EditCountryListView } from '@/components/EditCountryListView';
import { EDIT_LIST_TAB_RANK, EDIT_LIST_TAB_SELECT } from '@/constants/editListMobile';
import { RULES_DEMO_MAX_H } from '@/constants/rulesDemoMobile';
import { RULES_DEMO_COUNTRY_LIST } from '@/constants/rulesDemoCountryList';

/** Selection grid only — half of edit-list flag fill (0.75). */
const RULES_SELECTION_FLAG_BOX_FILL = 0.375;

/** Selection labels — smaller than edit list (11–12px). */
const RULES_SELECTION_LABEL_FONT_SIZE = { base: 9, sm: 10 } as const;

const demoScrollProps = {
  flex: 1,
  minH: 0,
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  sx: { WebkitOverflowScrolling: 'touch' },
};

export function RulesRankTeamsDemo(props?: { embeddedInModal?: boolean }) {
  const cardBackground = useColorModeValue('gray.50', 'gray.700');
  const embeddedInModal = props?.embeddedInModal ?? false;
  const isMobileLayout = useBreakpointValue({ base: true, lg: false }) ?? true;
  const demoMaxH = embeddedInModal ? undefined : RULES_DEMO_MAX_H;
  const selectionLabelFontSize = useBreakpointValue(RULES_SELECTION_LABEL_FONT_SIZE) ?? 9;
  const [mobilePanel, setMobilePanel] = useState(0);

  const editor = (
    <EditCountryListView
      countryList={RULES_DEMO_COUNTRY_LIST}
      setCountryList={() => {}}
      readOnly
      hideStepHeadings
      alignRankToSelection={!isMobileLayout}
      selectionFlagBoxFill={RULES_SELECTION_FLAG_BOX_FILL}
      selectionLabelFontSize={selectionLabelFontSize}
      selectionColumns={6}
      mobileProps={isMobileLayout ? { panel: mobilePanel === 0 ? 'selection' : 'ranking' } : undefined}
    />
  );

  return (
    <Box w='full' maxW='100%'>
      <Box
        w='full'
        h='fit-content'
        maxH={demoMaxH}
        display='flex'
        flexDirection='column'
        borderRadius='md'
        p={{ base: 3, md: 4 }}
        pb={{ base: 4, md: 5 }}
        background={cardBackground}
        overflow='hidden'
        aria-readonly
        aria-label='Example team selection and ranking'
      >
        <Show below='lg'>
          <Tabs
            index={mobilePanel}
            onChange={setMobilePanel}
            variant='enclosed'
            colorScheme='green'
            size='sm'
            display='flex'
            flexDirection='column'
            flex={1}
            minH={0}
            maxH={demoMaxH}
          >
            <TabList flexShrink={0} mb={0}>
              <Tab fontSize='sm'>{EDIT_LIST_TAB_SELECT}</Tab>
              <Tab fontSize='sm'>{EDIT_LIST_TAB_RANK}</Tab>
            </TabList>
            <TabPanels flex={1} minH={0} display='flex' flexDirection='column'>
              <TabPanel p={0} pt={3} flex={1} minH={0} display='flex' flexDirection='column'>
                <Box {...demoScrollProps}>{editor}</Box>
              </TabPanel>
              <TabPanel p={0} pt={3} flex={1} minH={0} display='flex' flexDirection='column'>
                <Box {...demoScrollProps}>{editor}</Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Show>
        <Show above='lg'>
          <Box w='full' display='flex' flexDirection='column' overflow='visible'>
            {editor}
          </Box>
        </Show>
      </Box>
    </Box>
  );
}
